import { Component, OnInit, Input } from '@angular/core';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { AppService } from 'src/app/app.service';
import { ProductService } from 'src/app/services/api/product/product.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { JsonComponent } from 'src/app/core/json/json.component';
@Component({
  selector: 'app-services-details',
  templateUrl: './services-details.component.html',
  styleUrls: ['./services-details.component.css']
})
export class ServicesDetailsComponent implements OnInit {

  appData: any;
  type: string;

  _summary: OrderSummary;
  @Input()
  get summary(): any {
    return this._summary;
  }
  set summary(value: any) {
    this._summary = value;
    this.ngOnInit();
  }
  _scaiReferenceObject: string;
  @Input()
  get scaiReferenceObject(): any {
    return this._scaiReferenceObject;
  }
  set scaiReferenceObject(value: any) {
    this._scaiReferenceObject = value;
    this.ngOnInit();
  }

  json: any;
  jsonRef: MatDialogRef<JsonComponent>;

  constructor(private appService: AppService,
    private productService: ProductService, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.appData = this.appService.settings;

    if (this._summary && this._summary.type.name === 'CFS') {
      this.type = 'servicio';
      this.productService.getInventoryCFS(this._summary.serviceRef).subscribe(
        data => {
          this.json = data;
          delete this.json._links;
        }
      );
    }
    if (this._summary && this._summary.type.name === 'RFS') {
      this.type = 'recurso';
      this.productService.getInventoryRFS(this._summary.serviceRef).subscribe(
        data => {
          this.json = data;
          delete this.json._links;
        }
      );
    }
  }

  showInventoryService() {
    if (this._summary.type.name === 'CFS') {

      this.jsonRef = this.dialog.open(JsonComponent, {
        data: { title: 'Información del CFS en inventario', json: this.json },
        width: '850px'
      });
    }
    if (this._summary.type.name === 'RFS') {

      this.jsonRef = this.dialog.open(JsonComponent, {
        data: { title: 'Información del RFS en inventario', json: this.json },
        width: '850px'
      });
    }
  }

}
